// extracted by mini-css-extract-plugin
export default {"label":"label__livC7","__fade":"__fade__rC1s9"};